import React from 'react'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { Button, Stack, Tooltip } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import SettingsBox from './SettingsBox'

interface Props {
  title: string
  boxTitle: string
  buttonText: string
  redirectUrl: string
  isRedirectDisabled?: boolean
  disabledTooltip?: string
}

/**
 * Generic accordion card that hints users to navigate to the page hosting a moved setting.
 */
const SettingsRedirectHintCard: React.FC<Props> = ({ title, boxTitle, buttonText, redirectUrl, isRedirectDisabled, disabledTooltip }) => {
  const navigate = useNavigate()

  return (
    <AccordionItem title={title} expanded={false}>
      <Stack p={2}>
        <SettingsBox
          title={boxTitle}
          suffix={
            <Tooltip title={disabledTooltip}>
              <span>
                <Button variant="text" onClick={() => navigate(redirectUrl)} disabled={isRedirectDisabled}>
                  {buttonText}
                </Button>
              </span>
            </Tooltip>
          }
        />
      </Stack>
    </AccordionItem>
  )
}

export default SettingsRedirectHintCard
